import { h } from 'preact'
import Icon, { IconType } from '../assets'

interface Props {
    title: string,
    statusText?: string,
    iconCustomClass?: string,
    customClass?: string,
    icon?: IconType,
    isDone?: boolean,
    meta?: string
}

export const PanelHeaderWithIcon = ({ title, statusText, iconCustomClass = '', icon, customClass = '', isDone, meta } : Props) => (
  <div className={customClass}>
    { icon && <Icon customClass={iconCustomClass} icon={icon} />}
    <div className='panel-header-title-wrapper'>
      <div className='panel-header-title'>
        {title}
        { isDone && <Icon color='#24C25E' icon='answer' width={20} height={20} /> }
        { statusText && <span className={`panel-header-status status-${statusText}`}>{statusText}</span> }
      </div>
      { meta && <div className='panel-header-meta'>{meta}</div> }
    </div>
  </div>
)
